"use strict";

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("@creditas/utils");

var _propTypes = require("prop-types");

var _utils2 = require("./utils");

var _Stepper = require("./components/Stepper");

var _StepperComponent = require("./StepperComponent");

var _core = require("@emotion/core");

var rangeType = (0, _propTypes.shape)({
  amount: _propTypes.number,
  label: _propTypes.string
});
var messagesType = (0, _propTypes.shape)({
  min: _propTypes.string,
  max: _propTypes.string,
  required: _propTypes.string
});
var propTypes = {
  min: rangeType.isRequired,
  max: rangeType.isRequired,
  increment: _propTypes.number.isRequired,
  messages: messagesType,
  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  locale: _propTypes.string,
  prefix: _propTypes.string,
  suffix: _propTypes.string,
  label: _propTypes.string,
  placeholder: _propTypes.string,
  variant: _propTypes.string,
  message: _propTypes.string,
  required: _propTypes.bool,
  disabled: _propTypes.bool,
  onBlur: _propTypes.func,
  onInput: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onIncrement: _propTypes.func,
  onDecrement: _propTypes.func,
  onInvalid: _propTypes.func,
  onValid: _propTypes.func
};
var defaultProps = {
  component: 'input',
  variant: 'default',
  disabled: false,
  locale: 'pt-BR'
};
var enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes, defaultProps)); // eslint-disable-next-line max-lines-per-function

var element = enhancer(function (props) {
  var withRef = props.withRef,
      component = props.component,
      className = props.className,
      data = props.data,
      dataTestId = props['data-testid'],
      label = props.label,
      placeholder = props.placeholder,
      defaultVariant = props.variant,
      defaultMessage = props.message,
      min = props.min,
      max = props.max,
      amountIncrement = props.increment,
      messages = props.messages,
      defaultAmount = props.value,
      prefix = props.prefix,
      suffix = props.suffix,
      locale = props.locale,
      required = props.required,
      disabled = props.disabled,
      _onInput = props.onInput,
      _onChange = props.onChange,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      _onIncrement = props.onIncrement,
      _onDecrement = props.onDecrement,
      onInvalid = props.onInvalid,
      onValid = props.onValid,
      other = _objectWithoutProperties(props, ["withRef", "component", "className", "data", "data-testid", "label", "placeholder", "variant", "message", "min", "max", "increment", "messages", "value", "prefix", "suffix", "locale", "required", "disabled", "onInput", "onChange", "onFocus", "onBlur", "onIncrement", "onDecrement", "onInvalid", "onValid"]);

  var ref = withRef ||
  /*#__PURE__*/
  (0, _react.createRef)();

  var format = function format(newAmount) {
    return (0, _utils2.formatNumbers)(newAmount, locale, prefix, suffix);
  };

  var _ref = (0, _react.useState)(function () {
    return defaultAmount ? format(defaultAmount) : '';
  }),
      _ref2 = _slicedToArray(_ref, 2),
      amount = _ref2[0],
      setAmount = _ref2[1];

  var _ref3 = (0, _react.useState)(defaultVariant),
      _ref4 = _slicedToArray(_ref3, 2),
      variant = _ref4[0],
      setVariant = _ref4[1];

  var _ref5 = (0, _react.useState)(defaultMessage),
      _ref6 = _slicedToArray(_ref5, 2),
      message = _ref6[0],
      setMessage = _ref6[1];

  var color = (0, _utils2.getColor)(variant);
  var minFormated = format(min.amount);
  var maxFormated = format(max.amount);

  var handleInvalid = function handleInvalid(type) {
    var errorMessage = (0, _utils2.generateMessage)(type, messages, minFormated, maxFormated);
    setMessage(errorMessage);
    setVariant('danger');
    onInvalid == null ? void 0 : onInvalid(_defineProperty({}, type, errorMessage));
  };

  var handleValid = function handleValid() {
    setMessage();
    setVariant('success');
    onValid == null ? void 0 : onValid();
  };

  var generateAmount = function generateAmount(newAmount) {
    return newAmount > 0 ? format(newAmount) : '';
  };

  var validateAmount = function validateAmount(newAmount) {
    if ((0, _utils2.isGreater)(newAmount, max)) handleInvalid('max');else if ((0, _utils2.isLower)(newAmount, min)) handleInvalid('min');else handleValid();
  };

  var updateAmount = function updateAmount(newAmount) {
    var rawAmount = (0, _utils2.stringToNumber)(newAmount);
    validateAmount(rawAmount);
    var formated = generateAmount(rawAmount);
    setAmount(formated);
  };

  var handleCalc = function handleCalc(callback) {
    if (disabled) return;
    var newAmount = callback(amount, amountIncrement, min, max);
    (0, _utils2.dispatchOnInput)(ref.current, newAmount);
  };

  return (0, _core.jsx)(_Stepper.Stepper, other, (0, _core.jsx)(_StepperComponent.StepperComponent, {
    ref: ref,
    component: component,
    className: className,
    "data-testid": dataTestId,
    label: label,
    value: amount,
    placeholder: placeholder,
    prefix: prefix,
    suffix: suffix,
    variant: variant,
    color: color,
    required: required,
    disabled: disabled,
    onInput: function onInput(e) {
      var rawValue = (0, _utils2.stringToNumber)(ref.current.value);
      updateAmount(rawValue);
      (0, _utils2.dispatchUpdatedChange)(e, rawValue, _onInput);
    },
    onChange: function onChange(e) {
      var rawValue = (0, _utils2.stringToNumber)(ref.current.value);
      updateAmount(rawValue);
      (0, _utils2.dispatchUpdatedChange)(e, rawValue, _onChange);
    },
    onFocus: function onFocus(e) {
      (0, _utils2.dispatchNativeEvent)(e, _onFocus);
    },
    onBlur: function onBlur(e) {
      if (required && function (value) {
        return !value || value === '';
      }(amount)) handleInvalid('required');
      (0, _utils2.dispatchNativeEvent)(e, _onBlur);
    },
    onIncrement: function onIncrement(e) {
      handleCalc(_utils2.increment);
      (0, _utils2.dispatchNativeEvent)(e, _onIncrement);
    },
    onDecrement: function onDecrement(e) {
      handleCalc(_utils2.decrement);
      (0, _utils2.dispatchNativeEvent)(e, _onDecrement);
    }
  }), (0, _core.jsx)(_Stepper.StepperRange, {
    "data-testid": "stepper-min"
  }, (0, _core.jsx)(_Stepper.StepperLine, null, min.label), (0, _core.jsx)(_Stepper.StepperLine, null, minFormated)), (0, _core.jsx)(_Stepper.StepperRange, {
    "data-testid": "stepper-max"
  }, (0, _core.jsx)(_Stepper.StepperLine, null, max.label), (0, _core.jsx)(_Stepper.StepperLine, null, maxFormated)), message && (0, _core.jsx)(_Stepper.StepperMessage, {
    color: color,
    "data-testid": "stepper-message"
  }, message));
});
exports.Stepper = element;